import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as messages from './../../messages/ReportsMessages';
import { MRI_STUDY_WARNING_TYPE_6, MRI_STUDY_WARNING_TYPE_7, MRI_STUDY_WARNING_TYPE_8 } from '../../constants';
import { isMRISpecificStudy } from '../../util/QuickReportsUtils';

const QuickReportFootNote = props => {
  const warningType = props.studyInfo.wnt;
  if (isMRISpecificStudy(props.studyInfo)) {
    if (warningType === MRI_STUDY_WARNING_TYPE_6) {
      return (
        <div className="quick-report-uncommon-asterisks">
          <div className={props.className}>
            {props.showSingleAsterisk || props.showDoubleAsterisk
              ? messages.MRI_CELL_COUNT_BELOW_50
              : ''}
          </div>
        </div>
      );
    } else if (warningType === MRI_STUDY_WARNING_TYPE_7) {
      return (
        <div className="quick-report-uncommon-asterisks">
          <div className={props.className}>
            {props.showSingleAsterisk || props.showDoubleAsterisk
              ? messages.MRI_CELL_COUNT_25_49
              : ''}
          </div>
          <div className={props.className}>
            {props.showDoubleAsterisk || props.showSingleAsterisk
              ? messages.MRI_CELL_COUNT_BELOW_25
              : ''}
          </div>
        </div>
      );
    } else if (warningType === MRI_STUDY_WARNING_TYPE_8) {
      return (
        <div className="quick-report-uncommon-asterisks">
          <div className={props.className}>
            {props.showSingleAsterisk || props.showDoubleAsterisk
              ? messages.MRI_CELL_COUNT_31_59
              : ''}
          </div>
          <div className={props.className}>
            {props.showDoubleAsterisk || props.showSingleAsterisk
              ? messages.MRI_CELL_COUNT_BELOW_31
              : ''}
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="quick-report-uncommon-asterisks">
        <div className={props.className}>
          {props.showSingleAsterisk || props.showDoubleAsterisk
            ? messages.CELL_COUNT_31_60
            : ''}
        </div>
        <div className={props.className}>
          {props.showDoubleAsterisk || props.showSingleAsterisk
            ? messages.CELL_COUNT_BELOW_31
            : ''}
        </div>
      </div>
    );
  }
};

QuickReportFootNote.propTypes = {
  className: PropTypes.string,
  studyInfo: PropTypes.shape({
    ss: PropTypes.string,
    wnt: PropTypes.number,
    // studyDescription: PropTypes.string,
  }),
  showSingleAsterisk: PropTypes.string,
  showDoubleAsterisk: PropTypes.string,
};

export default QuickReportFootNote;
